import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiUpload';
export const ENDPOINT_API_PATH = 'file-upload';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_X_API_KEY';
const URL_POSTMAN = '#';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
    bussinessErrorVariant: 'errorService',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
